import request from '../plugins/axios'

export function login (data) {
  return request({
    url: '/tim/agora/user/sign',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function logout (data) {
  return request({
    url: '/logout',
    method: 'post',
    data
  })
}
export function userCurrent (data) {
  return request({
    url: '/user/current',
    method: 'post',
    data
  })
}

export function userMenu(data) {
  return request({
      url: '/user/menu',
      method: 'post',
      data
  })
}

export function coursewareList (data) {
  return request({
    url: '/tim/sic/document/list',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function getCosAuth (data) {
  return request({
    url: '/tim/sic/document/auth',
    ContentType:"form",
    method: 'post',
    data
  })

}
export function coursewareAdd (data) {
  return request({
    url: '/tim/sic/document/add',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function onLineList (data) {
  return request({
    url: '/tim/sic/user/online/list',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function updateUserStageState (data) {
  return request({
    url: '/tim/sic/control/updateUserStageState',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function updateUserHandState (data) {
  return request({
    url: '/tim/sic/control/updateUserHandState',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function updateUserWhiteboardState (data) {
  return request({
    url: '/tim/sic/control/updateUserWhiteboardState',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function updateUserCameraState (data) {
  return request({
    url: '/tim/sic/control/updateUserCameraState',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function updateUserMikeState (data) {
  return request({
    url: '/tim/sic/control/updateUserMikeState',
    ContentType:"form",
    method: 'post',
    data
  })
}


export function updateSilenceState (data) {
  return request({
    url: '/tim/sic/control/updateSilenceState',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function updateUserMainVideoState (data) {
  return request({
    url: '/tim/sic/control/updateUserMainVideoState',
    ContentType:"form",
    method: 'post',
    data
  })
}
export function sicClassState (data) {
  return request({
    url: '/tim/sic/class/state',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function allOnStageUsers (data) {
  return request({
    url: '/tim/sic/control/get/stage/list',
    ContentType:"form",
    method: 'post',
    data
  })
}

export function getUserInfo (data) {
  return request({
    url: '/tim/sic/user/info',
    ContentType:"form",
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js